- title: Unlocking Collective Automation with Lightweight Multi-Agent Pathfinding
  year: 2026
  month: 9
  authors: Keisuke Okumura
  conf: Seminar Talk, Amazon Robotics
  place:
    en: Boston, US 🇺🇸
    ja: アメリカ・ボストン
  url: https://www.amazon.jobs/content/en/teams/ftr/amazon-robotics
  selected: true
- title: The Cutting Edge of Algorithmic Multi-Agent Pathfinding
  year: 2026
  month: 9
  authors: Keisuke Okumura
  conf: Seminar Talk, Zardini Lab, MIT
  place: Cambridge, US 🇺🇸
  url: https://zardini.mit.edu/
  #
- title:
    en: Scalable Multi-Agent Path Finding
    ja: スケーラブルなマルチエージェント経路計画
  year: 2026
  month: 9
  authors: Keisuke Okumura
  conf:
    en: Osaka University, MMDS
    ja: 大阪大学 MMDS AI・データ利活用研究会
  place:
    en: Online
    ja: オンライン
  url: https://www-mmds.sigmath.es.osaka-u.ac.jp/structure/activity/ai_data.php?id=117
- title: Concrete Multi-Agent Path Planning Enabling Kinodynamically Aggressive Maneuvers
  year: 2026
  month: 8
  authors: Keisuke Okumura
  conf: Seminar Talk, IMRC Lab, TU Berlin
  place: Berlin, Germany 🇩🇪
  url: https://imrclab.github.io/
  talk: https://www.youtube.com/watch?v=k7ExaSpARtE
- title: Combinatorial Search with Generators to Solve Collective Automation
  year: 2026
  month: 8
  authors: Keisuke Okumura
  conf: SoCS-26 Master Class
  place: Bremerhaven, Germany 🇩🇪
  url: https://socs26.search-conference.org/talks/master-classes
  selected: true
- title: Bridging Discrete Planning and Continuous Execution for Multi-Robot Trajectories
  year: 2026
  month: 6
  authors: Keisuke Okumura
  conf: Seminar Talk, AI Robotics Lab, Sogang University
  place:
    en: Online
    ja: オンライン
  url: https://airobotics.sogang.ac.kr/
- title: Solving Collective Automation with Lightweight Multi-Agent Pathfinding
  year: 2026
  month: 4
  authors: Keisuke Okumura
  conf: Seminar Talk, IDM Lab, USC/UCI
  place:
    en: Online
    ja: オンライン
  url: https://idm-lab.org/
- title: From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination
  year: 2026
  month: 4
  authors: Keisuke Okumura
  conf:
    en: Seminar Talk, SDS, Hitotsubashi University
    ja: 一橋大学大学院ソーシャル・データサイエンス研究科セミナー
  place:
    en: Online
    ja: オンライン
  url: https://www.sds.hit-u.ac.jp/3940/
- title: From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination
  year: 2026
  month: 3
  authors: Keisuke Okumura
  conf: Autonomy Talks, Zardini Lab, MIT
  selected: true
  place:
    en: Online
    ja: オンライン
  talk: https://www.youtube.com/watch?v=xI84VltsVRw
  url: https://zardini.mit.edu/autonomytalks/
  #
- title: Panel Discussion - Aligning Research Direction Between Academia and Industry
  year: 2026
  month: 1
  authors: Keisuke Okumura
  conf: International Workshop on Multi-Agent Path Finding (WoMAPF)
  place: Singapore 🇸🇬
  url: https://mapf-workshop.github.io/aaai26/
  #
- title: Upgrading Multi-Agent Pathfinding for the Real World
  year: 2025
  month: 10
  authors: Keisuke Okumura
  conf: European Workshop on Multi-Agent Pathfinding (EurMAPF-25)
  place: Bologna, Italy 🇮🇹
  url: https://sites.google.com/view/eurmapf25
  talk: https://speakerdeck.com/kei18/upgrading-multi-agent-pathfinding-for-the-real-world
  speakerdeck: https://speakerdeck.com/kei18/upgrading-multi-agent-pathfinding-for-the-real-world
  selected: true
- title: From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination
  year: 2025
  month: 9
  authors: Keisuke Okumura
  conf: The 9th ISM-ISCT-NII-ZIB-NUS-MODAL Workshop on Optimization and Machine Learning for Data Science and Future Computing (OPTDS-25)
  place: Tokyo, Japan 🇯🇵
  url: https://sites.google.com/view/optds2025/
- title: From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination
  year: 2025
  month: 5
  authors: Keisuke Okumura
  conf: Seminar talk, Behavior in Networks Studies Unit, the University of Tokyo
  place: Tokyo, Japan 🇯🇵
- title: Combinatorial Search with Generators
  year: 2024
  month: 5
  authors: Keisuke Okumura
  conf: Seminar talk, Optimisation group, Monash University
  place: Melbourne, Australia 🇦🇺
  speakerdeck: https://speakerdeck.com/kei18/combinatorial-search-with-generators
- title: Pathfinding for 10k agents - 2
  year: 2024
  month: 5
  authors: Keisuke Okumura
  conf: Agents-VIC Autumn Symposium 2024
  place: Melbourne, Australia 🇦🇺
  url: https://sites.google.com/view/agentsvic-autumn2024/home
- title: Remove Assumptions in Multi-Agent Pathfinding
  year: 2024
  month: 2
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf: Guest talk at idealworks
  place: Munich, Germany 🇩🇪
  speakerdeck: https://speakerdeck.com/kei18/remove-assumptions-in-multi-agent-pathfinding
- title: |
    Breaking Tradeoffs: Extremely Scalable Multi-Agent Pathfinding Algorithms
  year: 2024
  month: 2
  url: https://jiaoyangli.me/teaching/2024-spring-16891
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf: |
    Lectures on “Multi-Robot Planning and Coordination,” Robotics Institute, Carnegie Mellon University
  place:
    en: Online
    ja: オンライン
  speakerdeck: https://speakerdeck.com/kei18/breaking-tradeoffs-extremely-scalable-multi-agent-pathfinding-algorithms
  selected: false
- title: Pathfinding for 10k agents
  year: 2023
  month: 11
  selected: true
  url: https://talks.cam.ac.uk/talk/index/204508
  talk: https://www.cl.cam.ac.uk/seminars/wednesday/video/20231101-1500-t204508.html
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf: |
    Wednesday Seminars, the Department of Computer Science and Technology, University of Cambridge
  place: Cambridge, UK 🇬🇧
  speakerdeck: https://speakerdeck.com/kei18/pathfinding-for-10k-agents-5534305f-45e3-4712-9605-ef112be6a7c5
- abbr: SSII
  title:
    ja: マルチエージェント経路計画の基礎と最新動向
    en: Introductions to Multi-Agent Path Planning
  year: 2023
  month: 6
  url: https://confit.atlas.jp/guide/event/ssii2023/static/organized#OS3
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf:
    ja: 第29回画像センシングシンポジウム
    en: The 29th Symposium on Sensing via Image Information
  place:
    ja: オンライン
    en: Online
  speakerdeck: https://speakerdeck.com/ssii/ssii2023-os3-02
- title: Quick Multi-Agent Path Planning
  year: 2022
  month: 9
  authors: Keisuke Okumura
  conf: Seminar talks at Artificial Intelligence Lab@VUB, HyCoDeV Lab@Newcastle University, Prorok Lab@University of Cambridge
  place:
    en: Belgium 🇧🇪 / UK 🇬🇧
    ja: ベルギー 🇧🇪 / イギリス 🇬🇧
  speakerdeck: https://speakerdeck.com/kei18/quick-multi-agent-path-planning
- abbr: CoRe
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf:
    en: The 27th CoRe seminar
    ja: 組合せ遷移・第27回セミナー
  month: 7
  place:
    en: Online
    ja: オンライン
  speakerdeck: https://speakerdeck.com/kei18/navigation-for-a-team-of-agents
  style: oral
  title:
    en: Navigation for a team of agents
    ja: エージェント群のナビゲーション
  url:
    en: https://core.dais.is.tohoku.ac.jp/en/report/past-event/detail/---id-125.html
    ja: https://core.dais.is.tohoku.ac.jp/report/past-event/detail/---id-124.html
  year: 2022
- abbr: SIG-FPAI
  authors:
    en: Keisuke Okumura
    ja: 奥村 圭祐
  conf:
    en: Special Interest Group on Fundamental Problems in Artificial Intelligence
    ja: 人工知能学会 第116回人工知能基本問題研究会
  month: 3
  place:
    en: Online
    ja: オンライン
  speakerdeck: https://speakerdeck.com/kei18/on-controlling-swarm-of-moving-agents
  style: oral
  title:
    en: On Controlling Swarm of Moving Agents
    ja: 大規模な移動エージェント群の制御
  url: https://sig-fpai.org/past/fpai116.html
  year: 2021
- abbr: WDALFR
  authors: Keisuke Okumura
  conf: Workshop on Distributed Algorithms for Low-Functional Robots
  month: 11
  place: Nagasaki, Japan 🇯🇵
  speakerdeck: https://speakerdeck.com/kei18/cooperative-framework-for-multiple-moving-agents
  style: oral
  title: Cooperative Framework for Multiple Moving Agents
  url: https://sites.google.com/view/wdalfr/the-1st-wdalfr2019
  year: 2019
